import { YhBox } from '@/components/YhBox'
import { YHModal } from "@/components/YHModal";
import { PageHeader } from './PageHeader'
import { DataBox } from './DataBox'

export const SettleDetail = ({ code, setCode }) => {

    const onCancel = () => {
        if (code) {
            setCode(undefined);
        }
    }

    return (
        <>
            <YHModal visible={!!code} title="账单明细" showFooter={false} width={'80%'} height={"90%"} onCancel={onCancel}>
                <YhBox title="" style={{ height: 'calc(100vh - 185px)', padding: '0px 10px 0px 10px' }}>
                    <PageHeader />
                    <DataBox />
                </YhBox>
            </YHModal>
        </>
    )
}
